<script setup>
import { Link } from "@inertiajs/vue3";

let isLocalDebug = false;
if (import.meta.env.VITE_APP_ENV === "local") {
    isLocalDebug = true;
}

const props = defineProps(["href"]);
</script>

<template>
    <Link
        :href="href"
        class="inline-block rounded-lg px-2 py-1 text-sm font-normal hover:no-underline"
    >
        <slot />
    </Link>
</template>
